/**
 * Constants used throughout the application
 */

export const OVAL_RATIO = 1.3; // radiusY / radiusX
export const VERTICAL_RECT_RATIO = 1.45; // height / width

export const PHOTO_SHAPES = Object.freeze({
	OVAL: "oval",
	RECTANGLE: "rectangle",
});

export const MC_FONTS = [
	{ value: "Merriweather Bold 700", label: "Merriweather (Paryškintas)" },
	{
		value: "Merriweather Bold 700 Italic",
		label: "Merriweather (Paryškintas) Italic",
	},
	{
		value: "Playfair Display Medium 500",
		label: "Playfair Display (Vidutinis)",
	},
	{
		value: "Playfair Display Medium 500 Italic",
		label: "Playfair Display (Vidutinis) Italic",
	},
	{
		value: "Playfair Display SemiBold 600",
		label: "Playfair Display (Pusiau paryškintas)",
	},
	{
		value: "Playfair Display SemiBold 600 Italic",
		label: "Playfair Display (Pusiau paryškintas) Italic",
	},
	{
		value: "Playfair Display Bold 700",
		label: "Playfair Display (Paryškintas)",
	},
	{
		value: "Dancing Script Regular 400",
		label: "Dancing Script (Plonas)",
	},
	{ value: "Dancing Script Bold 700", label: "Dancing Script (Paryškintas)" },
	{
		value: "Cinzel Decorative Bold 700",
		label: "Cinzel Decorative (Paryškintas)",
	},
	{ value: "Kaushan Script", label: "Kaushan Script" },
	{ value: "Story Script", label: "Story Script" },
	{ value: "Playball", label: "Playball" },
	{ value: "Shafarik", label: "Shafarik" },
	{ value: "Monomakh", label: "Monomakh" },
	{ value: "Great Vibes", label: "Great Vibes" },
];

export const CF7_FORM_ID = 3393;
